import { render, staticRenderFns } from "./PaymentDetailsPage.vue?vue&type=template&id=16e276d6"
import script from "./PaymentDetailsPage.vue?vue&type=script&lang=js"
export * from "./PaymentDetailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports